import { DateTime } from 'luxon';

/**
 * Converts a date value that can be either a number[] (year, month, day, hour, minutes, seconds)
 * or an ISO string to an ISO string format.
 * @param date The date value to convert
 * @returns ISO formatted string
 */
export const normalizeDate = (date: number[] | string): string => {
	if (Array.isArray(date)) {
		const [year, month, day, hour = 0, minute = 0, second = 0] = date;
		return (
			DateTime.fromObject({
				year,
				month,
				day,
				hour,
				minute,
				second
			}).toISO() || ''
		);
	}
	return date;
};

/**
 * Formats a date (either number[] or ISO string) to a human-readable format
 * @param date The date value to format
 * @returns Formatted date string
 */
export const formatDate = (date: number[] | string): string => {
	const isoDate = normalizeDate(date);
	return DateTime.fromISO(isoDate).toLocaleString(DateTime.DATE_MED);
};
